module.exports = __webpack_public_path__ + "static/media/loading.ce797770.gif";